/**
 * A load that has to get somewhere before it is no good.
 *
 * A beat posts one (`chapters.js`, `posts`). Posting it loads the row's cart
 * where it is parked and starts the clock on the load, and that is all that is
 * authored. Getting it there is everything the game already had: pushing a
 * cart through the building, taking it down the apron stairs, hitching it to
 * the golf cart, and towing it the length of the cart road, where every bend
 * and every speed bump is a chance to put it over and spill it on the asphalt
 * through the one tipping rule every cart has.
 *
 *   cart      the cart from `data/wheeled.js`, sent home and loaded
 *   load      what goes on it and how many
 *   to        where it counts as delivered: a room, a point in feet, and how
 *             near the point the cart has to be stood
 *   melts     game minutes from posting until the load is worth nothing. It
 *             is worth less every minute on the way, slowly at first and
 *             then faster, and delivered it is worth what is left of it
 *   works     zones the job puts you in (`access.js`), like a strike
 *   award     standing for all of it, delivered the moment it was posted;
 *             scaled by how much arrived and how much of that was still good
 *   melted    standing when it never got there, or got there as water
 */
export const DELIVERIES = [
  {
    id: 'ice-run',
    title: 'Ice for the Caytons',
    cart: 'cart-ice',
    load: { kind: 'icebag', count: 12 },
    to: { room: 'caytons', at: [-414, 92], within: 40 },
    melts: 240,
    works: ['restricted-apron', 'caytons-zone'],
    award: { banquets: 10, kitchen: 4 },
    melted: { banquets: -5 },
  },
];

export const DELIVERIES_BY_ID = Object.freeze(Object.fromEntries(DELIVERIES.map((row) => [row.id, row])));

export default DELIVERIES;
